"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var types_generated_exports = {};
__export(types_generated_exports, {
  isAttributeSchema: () => isAttributeSchema,
  isBooleanAttributeSchema: () => isBooleanAttributeSchema,
  isFeatureDepsF: () => isFeatureDepsF,
  isFeatureDepsId: () => isFeatureDepsId,
  isFeatureDepsRef: () => isFeatureDepsRef,
  isIntegerAttributeSchema: () => isIntegerAttributeSchema,
  isJsonAttributeSchema: () => isJsonAttributeSchema,
  isMapAttribution: () => isMapAttribution,
  isMapBase: () => isMapBase,
  isMapLayerSummary: () => isMapLayerSummary,
  isMapSchemaSummary: () => isMapSchemaSummary,
  isNullableAttributeSchema: () => isNullableAttributeSchema,
  isNumberAttributeSchema: () => isNumberAttributeSchema,
  isStringAttributeSchema: () => isStringAttributeSchema,
  isTimestampAttributeSchema: () => isTimestampAttributeSchema
});
module.exports = __toCommonJS(types_generated_exports);
var import_geometry = require("@cartographerio/geometry");
var import_types_generated = require("../core/types.generated.js");
var import_types_generated2 = require("../survey/types.generated.js");
var import_util = require("@cartographerio/util");
const isFeatureDepsId = (v) => {
  return (0, import_util.bridgesIsTaggedHack)((a0) => a0 === "FeatureDepsId")(v);
};
const isFeatureDepsRef = (v) => {
  return typeof v === "object" && v != null && "layerId" in v && (0, import_types_generated.isMapLayerId)(v.layerId) && "featureId" in v && isFeatureDepsId(v.featureId);
};
const isMapBase = (v) => {
  return v === "terrain" || v === "satellite";
};
const isMapAttribution = (v) => {
  return typeof v === "string";
};
const isBooleanAttributeSchema = (v) => {
  return typeof v === "object" && v != null && "type" in v && v.type === "Boolean";
};
const isIntegerAttributeSchema = (v) => {
  return typeof v === "object" && v != null && "type" in v && v.type === "Integer";
};
const isNumberAttributeSchema = (v) => {
  return typeof v === "object" && v != null && "type" in v && v.type === "Number";
};
const isStringAttributeSchema = (v) => {
  return typeof v === "object" && v != null && "type" in v && v.type === "String";
};
const isTimestampAttributeSchema = (v) => {
  return typeof v === "object" && v != null && "type" in v && v.type === "Timestamp";
};
const isJsonAttributeSchema = (v) => {
  return typeof v === "object" && v != null && "type" in v && v.type === "Json";
};
const isNullableAttributeSchema = (v) => {
  return typeof v === "object" && v != null && "type" in v && v.type === "Nullable" && "param" in v && isAttributeSchema(v.param);
};
const isAttributeSchema = (v) => {
  return isBooleanAttributeSchema(v) || isIntegerAttributeSchema(v) || isNumberAttributeSchema(v) || isStringAttributeSchema(v) || isTimestampAttributeSchema(v) || isJsonAttributeSchema(v) || isNullableAttributeSchema(v);
};
const isMapLayerSummary = (v) => {
  return typeof v === "object" && v != null && "layerId" in v && (0, import_types_generated.isMapLayerId)(v.layerId) && "title" in v && typeof v.title === "string" && (!("geometryType" in v) || (0, import_geometry.isGeometryType)(v.geometryType) || v.geometryType === null) && "attribution" in v && Array.isArray(v.attribution) && v.attribution.every((i) => isMapAttribution(i));
};
const isMapSchemaSummary = (v) => {
  return typeof v === "object" && v != null && "mapId" in v && (0, import_types_generated.isMapId)(v.mapId) && "title" in v && typeof v.title === "string" && "layers" in v && Array.isArray(v.layers) && v.layers.every((i) => isMapLayerSummary(i));
};
const isFeatureDepsF = (isA) => (v) => {
  return typeof v === "object" && v != null && "geometry" in v && (0, import_geometry.isGeometry)(v.geometry) && "timestamp" in v && (0, import_types_generated.isTimestamp)(v.timestamp) && "data" in v && isA(v.data) && "status" in v && (0, import_types_generated2.isSurveyStatus)(v.status) && "workspaceIds" in v && Array.isArray(v.workspaceIds) && v.workspaceIds.every((i) => (0, import_types_generated.isWorkspaceId)(i)) && "id" in v && isFeatureDepsId(v.id);
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  isAttributeSchema,
  isBooleanAttributeSchema,
  isFeatureDepsF,
  isFeatureDepsId,
  isFeatureDepsRef,
  isIntegerAttributeSchema,
  isJsonAttributeSchema,
  isMapAttribution,
  isMapBase,
  isMapLayerSummary,
  isMapSchemaSummary,
  isNullableAttributeSchema,
  isNumberAttributeSchema,
  isStringAttributeSchema,
  isTimestampAttributeSchema
});
//# sourceMappingURL=types.generated.js.map
